"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const Company = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 14,
  height: 16,
  viewBox: "0 0 14 16"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  d: "M12.6 11.673v-2.37H7.7V7.813h3.004l-.226-.931C10.15 5.541 9.16 4.542 7.943 4.217A2.244 2.244 0 009.1 2.233C9.1 1.002 8.158 0 7 0 5.842 0 4.9 1.002 4.9 2.233c0 .869.474 1.614 1.157 1.984C4.84 4.542 3.85 5.54 3.522 6.883l-.226.931H6.3v1.488H1.4v2.37C.587 11.982 0 12.8 0 13.768 0 15 .942 16 2.1 16c1.158 0 2.1-1 2.1-2.233 0-.968-.587-1.786-1.4-2.094v-.882h3.5v.882c-.813.308-1.4 1.126-1.4 2.094C4.9 15 5.842 16 7 16c1.158 0 2.1-1 2.1-2.233 0-.968-.587-1.786-1.4-2.094v-.882h3.5v.882c-.813.308-1.4 1.126-1.4 2.094C9.8 15 10.742 16 11.9 16c1.158 0 2.1-1 2.1-2.233 0-.968-.587-1.786-1.4-2.094",
  className: "fill"
}));

var _default = Company;
exports.default = _default;